<template>
	<div class="pdf-export-dialog form-container">
		<nk-col-form-group :label="$t('table.export.pdf.dialog.paper-size') + ':'" :dataSizes="{ lg: 8 }" :labelSizes="{ lg: 4 }">
			<nk-dropdown v-model="paperSize.value" :options="paperSize.options" :tabindex="100" :data="paperSize.data"></nk-dropdown>
		</nk-col-form-group>

		<nk-col-form-group :label="$t('table.export.pdf.dialog.orientation-type') + ':'" :dataSizes="{ lg: 8 }" :labelSizes="{ lg: 4 }">
			<nk-dropdown v-model="orientation.value" :options="orientation.options" :tabindex="101" :data="orientation.data"></nk-dropdown>
		</nk-col-form-group>

		<nk-col-form-group :label="$t('table.export.pdf.dialog.theme') + ':'" :dataSizes="{ lg: 8 }" :labelSizes="{ lg: 4 }">
			<nk-dropdown v-model="theme.value" :options="theme.options" :tabindex="102" :data="theme.data"></nk-dropdown>
		</nk-col-form-group>

	</div>
</template>

<script>
	import $sc from '~/plugins/shortcut.collection.js'
	export default {
		name: 'PdfExportDialog',

		// Modal
		modal: {
			size: 'sm',
			stateUID: 'PdfExportDialog'
		},

		// Data
		data() {
			return {
				paperSize: {
					value: { name: 'A4', value: 'a4' },

					options: {
						required: true,
						display: (item) => {
							return item.name
						}
					},

					data: [
						{ name: 'A0', value: 'a0' },
						{ name: 'A1', value: 'a1' },
						{ name: 'A2', value: 'a2' },
						{ name: 'A3', value: 'a3' },
						{ name: 'A4', value: 'a4' },
						{ name: 'A5', value: 'a5' }
					]
				},

				orientation: {
					value: { name: this.$t('table.export.pdf.dialog.portrait'), value: 'portrait' },

					options: {
						required: true,
						placeholder: this.$t('select-it'),
						display: (item) => {
							return item.name
						}
					},

					data: [
						{ name: this.$t('table.export.pdf.dialog.portrait'), value: 'portrait' },
						{ name: this.$t('table.export.pdf.dialog.landscape'), value: 'landscape' }
					]
				},

				theme: {
					value: { name: 'Grid', value: 'grid' },

					options: {
						required: true,
						searchable: false,
						placeholder: this.$t('select-it'),
						display: (item) => {
							return item.name
						}
					},
					data: [
						{ name: 'Grid', value: 'grid' },
						{ name: 'Striped', value: 'striped' },
						{ name: 'Plain', value: 'plain' }
					]
				}
			}
		},

		// Mounted
		mounted() {
			this.prepareWindow(this.$t('table.export.pdf.dialog.title'), [
				{
					title: this.$t('table.export.export'),
					shortcut: $sc.find('save'),
					isPrimary: true,
					icon: 'file-export',

					handle: (button, page, e) => {
						const data = {
							paperSize: this.paperSize.value.value,
							orientation: this.orientation.value.value,
							theme: this.theme.value.value
						}
						this.resolve(data)
					}
				}
			])
		}
	}
</script>

<style>
	.pdf-export-dialog {
		padding: 20px;
	}
</style>
